import { $isAdamParagraphNode } from "../NotesPlugin/nodes/AdamParagraphNode/AdamParagraphNode.js";
import { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $isElementNode, $isTextNode } from "lexical";
import { mergeRegister } from "@lexical/utils";

//#region src/plugins/EditorPlaceholderPlugin/EditorPlaceholderPlugin.tsx
const defaultEmptyBlockCheck = (node) => {
	if (!$isElementNode(node)) return false;
	if (!$isAdamParagraphNode(node)) return false;
	const textContent = node.getTextContent();
	if (textContent.length > 0) return false;
	const children = node.getChildren();
	for (let i = 0; i < children.length; i++) {
		const child = children[i];
		if (!$isTextNode(child)) return false;
	}
	return true;
};
const $canShowPlaceholder = (isDefaultElementBlock = defaultEmptyBlockCheck) => {
	const root = $getRoot();
	const children = root.getChildren();
	const childrenLength = children.length;
	if (childrenLength > 1) return false;
	for (let i = 0; i < childrenLength; i++) {
		const topBlock = children[i];
		if (!isDefaultElementBlock(topBlock)) return false;
	}
	return true;
};
const EditorPlaceholderPlugin = ({ placeholder, isDefaultElementBlock }) => {
	const [showPlaceholder, setShowPlaceholder] = useState(false);
	const [editor] = useLexicalComposerContext();
	useEffect(() => {
		const updateShowPlaceholderFlag = () => {
			const canShowPlaceholder = editor.getEditorState().read(() => $canShowPlaceholder(isDefaultElementBlock));
			setShowPlaceholder(canShowPlaceholder);
		};
		return mergeRegister(editor.registerUpdateListener(() => {
			updateShowPlaceholderFlag();
		}), editor.registerEditableListener(() => {
			updateShowPlaceholderFlag();
		}));
	}, [editor]);
	if (!showPlaceholder) return null;
	if (typeof placeholder === "function") return placeholder({ isEditable: editor.isEditable() });
	return placeholder;
};

//#endregion
export { EditorPlaceholderPlugin };
//# sourceMappingURL=EditorPlaceholderPlugin.js.map